<div class="title" mat-dialog-title>
  <div class="title-breadcrumb">
    @if (selectedMobilePhoneVariant && !isManualRegistration) {
      <span
        class="title-breadcrumb title-breadcrumb-navigation"
        (click)="backToMobileSearch.emit()"
        (keydown.enter)="backToMobileSearch.emit()"
      >
        @if (selectedMobilePhoneVariant) {
          <mat-icon [svgIcon]="IconNames.ice_arrow_left" />
        }
        <a
          data-testid="phone-search-breadcrumb-link"
          tabindex="0"
          [ngClass]="{ 'active-title-text': !selectedMobilePhoneVariant }"
        >
          {{ searchPageText }}
        </a>
      </span>
    } @else {
      <span>{{ searchPageText }}</span>
    }
    @if (selectedMobilePhoneVariant && !isManualRegistration) {
      <span>/</span>
      <span class="active-title-text">{{ detailsPageText }}</span>
    }
    @if (isManualRegistration) {
      <span>/</span>
      <span class="active-title-text">Manuell registrering</span>
    }
  </div>
  <app-ice-icon-button
    matDialogClose
    size="40px"
    testId="close-mobile-search-dialog-button"
    [iconName]="IconNames.ice_close"
  />
</div>
